import * as React from "react";

import { enUS as enDateFns } from 'date-fns/locale';
import { enUS as enMaterial } from "@mui/material/locale";
import { hr as hrDateFns } from 'date-fns/locale';
import { hrHR as hrMaterial } from "@mui/material/locale";
import {dynamicActivateLocale} from "./locales";
import {changeLocale, initialState, LocaleState} from "./localeSlice";
import {createTheme} from "@mui/material/styles";
import {useDispatch, useSelector} from "react-redux";
import {useMemo} from "react";
import {Localization} from "@mui/material/locale";
import {useAppDispatch, useAppSelector} from "../../../../app/store.tsx";
import { useLocalStorage } from 'react-use';

export type LocalizationMap = { [id: string]: Localization };

const dateFnsLocales = {
    
    enUS: enDateFns,
    hr: hrDateFns,
}

const muiLocales: LocalizationMap = {
    
    en: enMaterial,
    hr: hrMaterial,
}

export const LOCALE_TOKEN_KEY = 'locale';

export function useLocale() {
    const [prefsToken, setPrefsToken] = useLocalStorage(LOCALE_TOKEN_KEY)
    const dispatch = useAppDispatch()
    let localeState: LocaleState = useAppSelector(state => state.locale)

    React.useEffect(() => {
        if (!localeState.updated) {
            try {
                const preferences = prefsToken && JSON.parse(prefsToken) || {};
                if (preferences) {
                    localeState = preferences;
                    dispatch(changeLocale(localeState))
                }
            } catch (error) {
                console.error('Failed to read preferences: ', error);
            }
        }
    }, [localeState.updated])

    React.useEffect(() => {
        if (localeState.updated) {
            setPrefsToken(JSON.stringify(localeState))
        }
    }, [localeState])

    const selectLocaleKey = React.useCallback((localeKey: string) => {
        dispatch(changeLocale({localeKey}))
    }, [dispatch])

    React.useEffect(() => {
        if (localeState.localeKey) {
            dynamicActivateLocale(localeState.localeKey)
        }
    }, [localeState.localeKey])

    return {
        localeKey: localeState.localeKey,
        selectLocaleKey,
        dateFnsLocale: dateFnsLocales[localeState.localeKey],
    }
}

const theme = createTheme({
    colorSchemes: {
        dark: true,
    },
});

export function useLocaleTheme(
    defaultLocaleKey: string | undefined = undefined
) {
    const dispatch = useDispatch();
    const { localeKey: localeKeyState } = useSelector((state: { 'locale': any }) => state.locale);

    const localeKey = localeKeyState ?? defaultLocaleKey;

    const themeWithLocale = useMemo(
        () => {
            if (localeKey) {
                if (localeKey !== localeKey) {
                    dispatch(changeLocale({localeKey}))
                }
                return createTheme(theme, muiLocales[localeKey])
            } else {
                return theme
            }
        },
        [localeKey, theme]
    );

    return {
        themeWithLocale,
    };
}
